import React, { useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import AgendaPage from "./AgendaPage";
import TeamAgendaPanel from "./TeamAgendaPanel";
import TeamWorkspaceLayout from "../Team/components/TeamWorkspaceLayout";
import { TEAM_BASE } from "../../utils/teamNavigation";
import { TEAM_MOBILE_MEDIA_QUERY, getTeamPaneContainerStyle } from "../Team/utils/teamUiUtils";

export { default as TeamAgendaPanel } from "./TeamAgendaPanel";

function AgendaRouteContent({ basePath }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(TEAM_MOBILE_MEDIA_QUERY);
  const containerStyle = useMemo(
    () => getTeamPaneContainerStyle(theme, isMobile),
    [theme, isMobile]
  );

  if (isMobile) {
    return (
      <TeamAgendaPanel
        containerStyle={containerStyle}
        isMobile
        basePath={basePath}
        fullPage
      />
    );
  }

  return <AgendaPage basePath={basePath} />;
}

const TeamAgendaRoutes = ({ basePath = TEAM_BASE, standalone = false }) => (
  <TeamWorkspaceLayout
    basePath={basePath}
    activeSection="agenda"
    contentScroll={false}
    standalone={standalone}
  >
    <Routes>
      <Route index element={<AgendaRouteContent basePath={basePath} />} />
    </Routes>
  </TeamWorkspaceLayout>
);

export default TeamAgendaRoutes;
